import React from 'react';
import { Head } from '@inertiajs/react';
import PostForm from '@/components/admin/blog/PostForm';

interface Category {
  id: number;
  name: string;
  slug: string;
}

interface Tag {
  id: number;
  name: string;
  slug: string;
}

interface Props {
  post?: any;
  categories: Category[];
  tags: Tag[];
}

const New: React.FC<Props> = ({ categories, tags }) => {
  return (
    <>
      <Head title="New Post" />
      <PostForm categories={categories} tags={tags} isEditing={false} />
    </>
  );
};

export default New;
